import "../App.css";
import DevInfo from "./DevInfo";
import Home from "./Home";
import AboutMe from "./AboutMe";
import MyProjects from "./MyProjects";
import ContactMe from "./ContactMe";
import Extras from "./Extras";
import MobileDrawer from "./MobileDrawer";

export default function Platform() {
  return (
    <section className="platform p-0">
      <div className="container-fluid h-100">
        <div className="row h-100">
          <div
            className="devinfo col-md-2 d-none d-sm-block p-0 h-100"
            tabIndex="-1"
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <DevInfo />
          </div>
          <div className="main col-md-10 p-0 h-100">
            <ul
              className="nav nav-tabs nav-justified flex-row"
              // className="nav nav-tabs nav-justified flex-column flex-sm-row d-none d-md-flex"
              // aria-orientation="vertical"
              role="tablist"
              id="mainTab"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="home-tab-pane"
                  aria-selected="true"
                >
                  <span>
                    <i className="fas fa-house"></i>
                    <small className="d-block d-md-none">home</small>
                  </span>
                  <span className="d-none d-md-inline">&nbsp;home</span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="about-me-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#about-me-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="about-me-tab-pane"
                  aria-selected="false"
                >
                  <span>
                    {/* <i className="fas fa-address-card"></i> */}
                    <i className="fas fa-id-card"></i>
                    <small className="d-block d-md-none">about</small>
                  </span>
                  <span className="d-none d-md-inline">&nbsp;about-me</span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="my-projects-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#my-projects-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="my-projects-tab-pane"
                  aria-selected="false"
                >
                  <span>
                    <i className="fas fa-diagram-project"></i>
                    <small className="d-block d-md-none">projects</small>
                  </span>
                  <span className="d-none d-md-inline">&nbsp;my-projects</span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="contact-me-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#contact-me-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="contact-me-tab-pane"
                  aria-selected="false"
                >
                  <span>
                    <i className="fas fa-address-book"></i>
                    <small className="d-block d-md-none">contact</small>
                  </span>
                  <span className="d-none d-md-inline">&nbsp;contact-me</span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link position-relative text-center"
                  id="extras-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#extras-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="extras-tab-pane"
                  aria-selected="false"
                >
                  <span>
                    {/* <i className="fas fa-puzzle-piece"></i> */}
                    <i className="fas fa-gamepad"></i>
                    <small className="d-block d-md-none">extras</small>
                  </span>
                  <span className="d-none d-md-inline">&nbsp;extras</span>
                </button>
              </li>
            </ul>
            <div className="tab-content p-4" id="mainTabContent">
              <Home />
              <AboutMe />
              <MyProjects />
              <ContactMe />
              <Extras />
            </div>
          </div>
        </div>

        <MobileDrawer />
      </div>
    </section>
  );
}
